export const budgetEndpoints = {
  getBudgets: { method: 'get', path: '/' },
  getBudget: { method: 'get', path: '/{budgetId}' },
  createBudget: { method: 'post', path: '/' },
  updateBudget: { method: 'post', path: '/{budgetId}/update' },
  deleteBudget: { method: 'post', path: '/{budgetId}/delete' },
} as const
